module.exports = __webpack_public_path__ + "static/media/apple_image.da75e339.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/apple_image.png
// module id = 76
// module chunks = 0